export enum BotStatus {
  Created = 'CREATED',
  Inactive = 'INACTIVE',
  Inactivate = 'INACTIVATE',
  Ready = 'READY',
  Switch_bots = 'SWITCH_BOTS',
  Configured = 'CONFIGURED',
}
